import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LoadingGif = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Box
        component="img"
        src="/icons/loading.gif"
        alt="Loading"
        sx={{
          width: "150px",
          height: "auto",
          mixBlendMode: "multiply",
        }}
      />
      <Typography
        variant="h6"
        color="black"
        sx={{
          fontSize: "1rem",
          color: "#000",
          textAlign: "center",
        }}
      >
        {t('Loading')}
      </Typography>
    </Box>
  );
};

export default LoadingGif;
